import React from 'react';
import dynamic from 'next/dynamic';
import { useIntl } from 'react-intl';
import Frontpage from '@fuww/library/src/Frontpage';
import { useSiteContext } from '../SiteContext';
import About from './Sections/About';
import ArticleLayout from '../News/ArticleLayout';
import Head from '../Head';
import HomeLink from '../HomeLink';
import LinkAndAnchor from '../LinkAndAnchor';
import InView from '../InView';
import messages from '../../lib/messages.mjs';
import loading from '../../lib/loading';

const CategoryTags = dynamic(() => import('./Sections/CategoryTags'), {
  ssr: false,
  loading,
});

const Executive = () => {
  const intl = useIntl();
  const { locale } = useSiteContext();
  const executiveManagementCategoryIds = locale === 'en-US' ? [10, 23] : [10];
  const executiveReportCategoryIds = locale === 'en-US' ? [10, 24] : [10];
  const newsBusinessCategoryIds = [10];

  const FEATURED_NEWS_QUERY_VARIABLES = {
    categoryIds: locale === 'en-US'
      ? executiveManagementCategoryIds
      : newsBusinessCategoryIds,
    featured: true,
  };
  const MORE_NEWS_QUERY_VARIABLES = {
    categoryIds: locale === 'en-US'
      ? executiveReportCategoryIds
      : newsBusinessCategoryIds,
  };

  const breadcrumbs = [
    <HomeLink />,
    <LinkAndAnchor
      route="executive"
      passHref
    >
      {intl.formatMessage(messages.executive)}
    </LinkAndAnchor>,
  ];

  return (
    <>
      <Head
        title={intl.formatMessage(messages.executiveTitle)}
        description={intl.formatMessage(messages.executiveMetaDescription)}
      />
      <Frontpage
        breadcrumbs={breadcrumbs}
        intro={intl.formatMessage(messages.executiveIntro)}
        description={intl.formatMessage(messages.executiveDescription)}
        mainSection={(
          <ArticleLayout
            featuredVariables={FEATURED_NEWS_QUERY_VARIABLES}
            moreNewsVariables={MORE_NEWS_QUERY_VARIABLES}
            showCreatedAt
            categorySection={(
              <InView>
                <CategoryTags
                  executiveManagementCategoryIds={
                    executiveManagementCategoryIds
                  }
                  executiveReportCategoryIds={executiveReportCategoryIds}
                />
              </InView>
            )}
          />
        )}
        aboutSection={(
          <About
            title={intl.formatMessage(messages.executiveIntro)}
            description={
              intl.formatMessage(messages.executiveNewsletterDescription)
            }
          />
        )}
      />
    </>
  );
};

export default Executive;
